const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

const label = (o) => {
  const a = o.shipping_address || {};
  return `<div class="l">
<div class="s"><div class="k">Mittente</div>MarkooPlace · EI SRL<br>Roma, Italia</div>
<div class="to"><div class="k">Destinatario</div><b>${esc(a.name)}</b><br>${esc(a.address)}<br>${esc(a.zip)} ${esc(a.city)}${a.province ? ` (${esc(a.province)})` : ""}${a.phone ? `<br>Tel. ${esc(a.phone)}` : ""}</div>
<div><div class="k">Ordine</div><span class="n">N. ${esc(o.number)}</span></div>
<div class="f">Contenuto: ${esc(o.quantity)} SIM Italia Mobile in plastica${o.tracking ? `<br>Tracking: ${esc(o.tracking)}` : ""}</div>
</div>`;
};

export const printSimLabels = (list) => {
  const items = list.filter((o) => o.shipping_address);
  if (!items.length) return false;
  const w = window.open("", "_blank", "width=520,height=640");
  if (!w) return false;
  w.document.write(`<!doctype html><html><head><title>${items.length > 1 ? `Etichette SIM (${items.length})` : `Etichetta ordine N. ${esc(items[0].number)}`}</title><style>
@page{size:100mm 150mm;margin:0}body{margin:0;font-family:Arial,sans-serif;color:#000}
.l{width:100mm;height:150mm;box-sizing:border-box;padding:7mm;border:1px dashed #999;display:flex;flex-direction:column;gap:5mm}
.s{font-size:9pt;line-height:1.35}.k{font-size:8pt;text-transform:uppercase;letter-spacing:.08em;color:#555}
.to{border:2px solid #000;padding:4mm;font-size:13pt;line-height:1.45}.to b{font-size:15pt}.n{font-size:22pt;font-weight:bold}
.f{margin-top:auto;font-size:9pt;border-top:1px solid #000;padding-top:3mm}.l{page-break-after:always;break-after:page}.l:last-child{page-break-after:auto;break-after:auto}@media print{.l{border:none}}</style></head><body>${items.map(label).join("")}<script>window.onload=function(){window.print()}</script></body></html>`);
  w.document.close();
  return true;
};

export const printSimLabel = (o) => printSimLabels([o]);
